import { RootState } from "../store";

export const selectCurrentInspectorState = (state: RootState) => state.templateEditor.currentInspectorState;

export const selectCurrentTemplate = (state: RootState) => state.templateEditor.currentTemplate;

export const selectCurrentCanvasData = (state: RootState) => state.templateEditor.currentTemplate?.canvas_data;

export const selectTemplateHasChanges = (state: RootState) => state.templateEditor.templateHasChanges;
